import { Link } from "react-router-dom";
import { Users, CaretRight, UserCircle } from "@phosphor-icons/react";

export default function MemberHome() {
  return (
    <div className="max-w-2xl" data-testid="member-home">
      <p className="eyebrow">Welcome</p>
      <h1 className="mt-1 font-display font-extrabold tracking-tighter text-3xl sm:text-4xl leading-none">
        Your club directory
      </h1>
      <p className="mt-3 t-support text-muted-foreground">
        Browse your club's member directory and keep your own directory details up to date.
      </p>
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        <Link to="/directory" data-testid="member-directory-card"
          className="border border-border bg-surface rounded-md p-5 hover:border-primary/40 transition-colors">
          <Users size={24} weight="duotone" className="text-primary" />
          <p className="mt-3 font-display font-extrabold tracking-tight">Club Directory</p>
          <p className="t-support text-muted-foreground">Members of your club</p>
          <span className="mt-2 flex items-center gap-1 text-sm text-primary font-semibold">Open <CaretRight size={13} weight="bold" /></span>
        </Link>
        <Link to="/profile" data-testid="member-directory-details-card"
          className="border border-border bg-surface rounded-md p-5 hover:border-primary/40 transition-colors">
          <UserCircle size={24} weight="duotone" className="text-primary" />
          <p className="mt-3 font-display font-extrabold tracking-tight">Directory Details</p>
          <p className="t-support text-muted-foreground">View and complete your own details</p>
          <span className="mt-2 flex items-center gap-1 text-sm text-primary font-semibold">Open <CaretRight size={13} weight="bold" /></span>
        </Link>
      </div>
    </div>
  );
}
